import { TagChoosability as TagChoosabilityEnum } from "@sinch/core/entities/serverEnums";
import { TagChoosability } from "@sinch/types/sinch.types";
import { useTranslation } from "react-i18next";
import { useEntityProps } from "@sinch/components/application/utilsHooks";

/**
 * Single source of truth for how a tag choosability looks in the app: label.
 *
 * Use these getters wherever a tag choosability is shown.
 * Never hardcode its label in a component, change them here.
 * Every value is shown in the "Entity Identity/TagChoosability" story.
 */
export const useTagChoosability = () => {
  const { t } = useTranslation();

  const positionRoles = {
    [TagChoosabilityEnum.Admin]: {
      label: t("Tag.choosability.admins"),
    },
    [TagChoosabilityEnum.Client]: {
      label: t("Tag.choosability.clients"),
    },
  } as Record<TagChoosabilityEnum | TagChoosability, { label: string }>;

  const getProp = useEntityProps(positionRoles);

  const getStatusLabel = getProp<string>("label");

  const getOptions = () =>
    Object.entries(positionRoles).map(([key, value]) => ({
      value: key,
      label: value.label,
    }));

  return { getStatusLabel, getOptions };
};
